export default __webpack_public_path__ + "static/media/BiomassGenerator.256.ca349a5d.png";